import { memo } from "react";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { View } from "@src/components";
import { PressableScale } from "pressto";
import { Icon } from "@src/components/Icon";

type AnimatedFullscreenButtonProps = {
  isFullscreen: boolean;
  onPress: () => void;
};

// Content only — corner positioning, z-index, and the fade animation are
// owned by the base `VideoPlayer` (packages/a3s-ui), same as
// `VideoControlButton` for the play/pause/previous/next slots. This
// component just renders what goes inside the fullscreen button.
export const AnimatedFullscreenButton = memo(({ isFullscreen, onPress }: AnimatedFullscreenButtonProps) => {
  const { theme } = useUnistyles();

  return (
    <PressableScale onPress={onPress} hitSlop={theme.spacing.md}>
      <View style={styles.button}>
        <Icon
          name={isFullscreen ? "fullscreenExit" : "fullscreen"}
          size={theme.spacing["5xl"]}
          color={theme.colors.mediaOverlay.foreground}
        />
      </View>
    </PressableScale>
  );
});

const styles = StyleSheet.create((theme) => ({
  button: {
    width: theme.spacing["8xl"],
    height: theme.spacing["8xl"],
    borderRadius: theme.spacing["2xl"],
    backgroundColor: theme.colors.mediaOverlay.backgroundMedium,
    alignItems: "center",
    justifyContent: "center",
  },
}));
